import { Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledChip = styled(Chip)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  border: "none",
  background: "transparent",
  color: theme.palette.grey[800],
  ".MuiChip-label": {
    width: "22px",
    height: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    background: "transparent"
  },
  ".MuiSvgIcon-root": {
    width: "20px",
    height: "20px"
  }
}));
export {
  StyledChip
};
